<template>
    <div class="followUp_details">
        <div class="followUp_message">
            <div class="title">
                <span>基本信息</span>
            </div>
           <ul class="followUp_content">
                <li class="followUp_hospital">
                    <div class="name">
                        <p>随访医院</p>
                    </div>
                    <div class="content">
                        <p>{{followDetail.hospital.name}}</p>
                    </div>
                </li>

                <li class="followUp_hospital">
                    <div class="name">
                        <p>随访医生</p>
                    </div>
                    <div class="content">
                        <p>{{followDetail.employee.name}}</p>
                    </div>
                </li>
                <li class="followUp_hospital">
                    <div class="name">
                        <p>随访时间</p>
                    </div>
                    <div class="content">
                        <p>{{followDetail.date}}</p>
                    </div>
                </li>
                <li class="followUp_hospital">
                    <div class="name">
                        <p>下次随访时间</p>
                    </div>
                    <div class="content">
                        <p>{{followDetail.scheduleDate}}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="followUp_message">
            <div class="title">
                <span>基本指标</span>
            </div>
           <ul class="followUp_content">
                <li class="followUp_hospital">
                    <div class="name">
                        <p>症状</p>
                    </div>
                    <div class="content">
                        <p>{{symptom.toString()}}</p>
                    </div>
                </li>

                <li >
                    <div class="name">
                        <p>辅助检查</p>
                    </div>
                    <div class="content">
                        <p>{{followDetail.otherInspection}}</p>
                    </div>
                </li>
                <li >
                    <div class="name">
                        <p>治疗方式</p>
                    </div>
                    <div class="content">
                        <p>{{followDetail.treatmentPrograms}}</p>
                    </div>
                </li>
                <li>
                    <div class="name">
                        <p>内分泌治疗</p>
                        <p>开始时间</p>
                    </div>
                    <div class="content">
                        <p>{{followDetail.endocrineTherapyStartTime}} 时长: {{followDetail.endocrineTherapyDuration}}</p>
                    </div>
                </li>
                 <!--<li >-->
                    <!--<div class="name">-->
                        <!--<p>内分泌治</p>-->
                        <!--<p>疗方案</p>-->
                    <!--</div>-->
                    <!--<div class="content">-->
                      <!--<p>{{followDetail.treatmentPrograms}}</p>-->
                        <!--&lt;!&ndash;<p>诺雷得</p>&ndash;&gt;-->
                        <!--&lt;!&ndash;<p>1次/28天 1支/每次</p>&ndash;&gt;-->
                    <!--</div>-->
                <!--</li>-->
                 <li>
                    <div class="name">
                        <p>用药依从性</p>
                    </div>
                    <div class="content">
                        <p>{{ medicationCompliance.toString() }}</p>
                    </div>
                </li>
                 <li>
                    <div class="name">
                        <p>随访分类</p>
                    </div>
                    <div class="content">
                        <p>{{followDetail.diagnosisAndClinicalStaging}}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="followUp_message">
            <div class="title">
                <span>PSA记录表</span>
                <span class="right">单位(ng/ml)</span>
            </div>
            <div id="echarts"></div>
        </div>
        <div class="followUp_message">
            <div class="title">
                <span>睾酮记录表</span>
                <span class="right">单位(ng/dl)</span>
            </div>
            <div id="echarts1"></div>
        </div>

    </div>
</template>

<script>
  import { base } from '@/apis'
  import hosts from '@/apis/hostConfig'
  import echarts from 'echarts'
export default {
    data(){
      return {
          id: this.$route.query.id,
          followDetail:{
            hospital:{},
            employee:{}
          },
          echartsValue: {
            dateArr:[],
            valArr:[]
//            dateArr:['2017-04-05','2017-06-06','2017-08-26','2017-10-12','2017-10-12','2018-03-10','2017-04-05','2017-06-06','2017-08-26','2017-10-12','2017-10-12','2018-03-10'],
//            valArr: [300, 500, 284, 790, 219, 253,300, 500, 284, 790, 219, 253]
          },
          echarts1Value: {
            dateArr:[],
            valArr:[]
//            dateArr:['2017-04-05','2017-06-06','2017-08-26','2017-10-12','2017-10-12','2018-03-10'],
//            valArr:[300, 500, 284, 790, 219, 253]
          },
          //用药依从性
          psaMedicationComSituation: [
            {
              name: "规律",
              val: "1"
            },
            {
              name: "间隙",
              val: "2"
            },
            {
              name: "不服药",
              val: "0"
            }
          ],
          medicationCompliance:[],
          psaSymptom: [
            {
              name: "排尿困难",
              val: "dyingDysuria"
            },
            {
              name: "尿频",
              val: "urinaryFrequency"
            },
            {
              name: "尿急",
              val: "urgency"
            },
            {
              name: "尿意不尽",
              val: "inexhaustible"
            },
            {
              name: "尿滴沥",
              val: "urineDrop"
            },
            {
              name: "尿潴留",
              val: "urinaryRetention"
            },
            {
              name: "疲劳",
              val: "fatigue"
            },
            {
              name: "体重减轻",
              val: "weightLoss"
            },
            {
              name: "骨骼疼痛",
              val: "skeletalPain"
            },
            {
              name: "其他",
              val: "other"
            }
          ],
          symptom:[],
      }
    },
    created(){
      this.detailsMessage();
    },
    mounted(){

    },
    watch:{
      followDetail(newval){
        this.followDetail=newval;
        for(let i=0;i<this.followDetail.medicationCompliance.length;i++){
          for(let k=0;k<this.psaMedicationComSituation.length;k++){
            if(this.psaMedicationComSituation[k].val==this.followDetail.medicationCompliance[i]){
              this.medicationCompliance.push(this.psaMedicationComSituation[k].name)
            }
          }
        }
        for(let i=0;i<this.followDetail.symptom.length;i++){
          for(let k=0;k<this.psaSymptom.length;k++){
            if(this.psaSymptom[k].val==this.followDetail.symptom[i]){
              this.symptom.push(this.psaSymptom[k].name)
            }
          }
        }
      }
    },
    methods: {
        detailsMessage() {
          this.axios.get(base.proxyGet,{
            params:{
              url:hosts[process.env.NODE_ENV].emr+'/PsaFollowUpRecords/'+this.id+'/detail'
            }
          }).then((res)=>{
            if(res.status==200 && res.data.code=='000000'){
              let data = JSON.parse(res.data.data);
              this.followDetail = data.data;
              console.log(this.followDetail)
              for(let i=0;i<this.followDetail.totalProstateSpecificAntigens.length;i++){
                if(this.followDetail.totalProstateSpecificAntigens[i].date && this.followDetail.totalProstateSpecificAntigens[i].totalProstateSpecificAntigen){
                  this.echartsValue.dateArr.push(this.followDetail.totalProstateSpecificAntigens[i].date);
                  this.echartsValue.valArr.push(this.followDetail.totalProstateSpecificAntigens[i].totalProstateSpecificAntigen);
                }
              }
              for(let k=0;k<this.followDetail.testosteroneTests.length;k++){
                if(this.followDetail.testosteroneTests[k].date && this.followDetail.testosteroneTests[k].testosteroneTest){
                  this.echarts1Value.dateArr.push(this.followDetail.testosteroneTests[k].date);
                  this.echarts1Value.valArr.push(this.followDetail.testosteroneTests[k].testosteroneTest);
                }
              }
//              console.log(this.echartsValue.dateArr)
//              console.log(this.echartsValue.valArr)
//              console.log(this.echarts1Value.dateArr)
//              console.log(this.echarts1Value.valArr)
              this.echartsPSA(this.echartsValue.dateArr,this.echartsValue.valArr);
              this.echarts(this.echarts1Value.dateArr,this.echarts1Value.valArr);

            }
          })
        },
        echartsPSA(dateArr,valArr) {   //PSA记录表
          let dataZoom = [];
          if(dateArr.length>=6){
            dataZoom = [
              {
                type: 'slider',
                show: false,
                xAxisIndex: [0],
                startValue:0,
                endValue:5
              },
              {
                type: 'inside',
                xAxisIndex: [0],
                startValue:0,
                endValue:5
              }
            ];
          }
           const option = {
                grid: {
                    left: '-6%',
                    right: '6%',
                    bottom: '1%',
                    top: '2%',
                    containLabel: true
                },
                 dataZoom: dataZoom,
                xAxis: {
                    type: 'category',
                    data: dateArr,
                    axisLabel:{
                        interval: 0,
                        rotate: 75,
                        textStyle:{ // x轴字体的样式
                            fontSize:"11px",
                            color:"#666",
                        },
                    },
                    axisTick:{
                        show: false,//是否显示坐标轴刻度线
                    },
                    axisLine:{//x轴、y轴坐标线的颜色
                        show: true,
                        lineStyle:{
                            color:"#d7d7d7",
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    max: 1000,
                    interval: 300,
                    show : false,  //去掉坐标
                    splitLine:{  //去掉网格线
                　　　　show:true
                　　},

                },
                series: [
                    {
                        name:'PSA记录表',
                        type:'line',
                        stack: '总量',
                        label: {
                            normal: {
                                show: true,
                                position: 'top',
                                textStyle: {
                                fontSize: 11,//设置字体大小
                                color:'#41B7A7'//设置柱子上面数据的颜色
                                }
                            }
                        },
                        itemStyle : {  //设置折线的颜色
                            normal : {
                                color: "#41B7A7", //折线圆点的颜色
                                lineStyle:{
                                    color:'#41B7A7',
                                    width: 1
                                }
                            }
                        },
                        data: valArr,
                    }
                ]
            };
            const myChart = echarts.init(document.getElementById('echarts'));
            myChart.setOption(option);

        },
        echarts(dateArr,valArr) {  //睾酮记录表
          let dataZoom = [];
          if(dateArr.length>=6){
            dataZoom = [
              {
                type: 'slider',
                show: false,
                xAxisIndex: [0],
                startValue:0,
                endValue:5
              },
              {
                type: 'inside',
                xAxisIndex: [0],
                startValue:0,
                endValue:5
              }
            ];
          }
            const option1 = {
                grid: {
                    left: '-6%',
                    right: '6%',
                    bottom: '1%',
                    top: '2%',
                    containLabel: true
                },
              dataZoom: dataZoom,
                xAxis: {
                    type: 'category',
                    data: dateArr,
                    axisLabel:{
                        interval: 0,
                        rotate: 75,
                        textStyle:{ // x轴字体的样式
                            fontSize:"11px",
                            color:"#666",
                        },
                    },
                    axisTick:{
                        show: false//是否显示坐标轴刻度线
                    },
                    axisLine:{//x轴、y轴坐标线的颜色
                        show: true,
                        lineStyle:{
                            color:"#d7d7d7",
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    max: 1000,
                    interval: 300,
                    show : false,  //去掉坐标
                    splitLine:{  //去掉网格线
                　　　　show:false
                　　},

                },
                series: [
                    {
                        name:'睾酮记录表',
                        type:'line',
                        stack: '总量',
                        label: {
                            normal: {
                                show: true,
                                position: 'top',
                                textStyle: {
                                fontSize: 11,//设置字体大小
                                color:'#41B7A7'//设置柱子上面数据的颜色
                                }
                            }
                        },
                        itemStyle : {  //设置折线的颜色
                            normal : {
                                color: "#41B7A7", //折线圆点的颜色
                                lineStyle:{
                                    color:'#41B7A7',
                                    width: 1
                                }
                            }
                        },
                        data: valArr,
                    }
                ]
            };
            const myChart1 = echarts.init(document.getElementById('echarts1'));
            myChart1.setOption(option1);
        }
    }
}

</script>

<style scoped lang="scss">
.followUp_details {
  @include width_height_100();
    .followUp_message {
        width: 100%;
        background: #fff;
        margin-bottom: 20px;
        .title {
            position: relative;
            height: 40px;
            line-height: 40px;
            padding-left: 15px;
            color: #14c3b3;
            margin-top: 10px;
            font-size: 14px;
            .right{
                position: absolute;
                right: 15px;
                top:0;
                height: 100%;
                color: #333;
            }
        }
        .title::after{
            content: '';
            position: absolute;
            left: 0;
            top: 10px;
            width: 4px;
            height: 20px;
            display: block;
            background: #14c3b3;
        }
        .followUp_content {
            overflow: hidden;
            background: #fff;
            li{
                width: 100%;
                padding: 10px 15px;
                display: flex;
                border-bottom: 1px solid #ddd;
                align-items:center; /* 垂直居中 */
            }
            li:last-child{
                border-bottom: 0;
            }
            .name{
                width: 100px;
            }
            .name p{
                font-size: 15px;
                line-height: 18px;
                color: #a8a8a8;
            }
            .content{
                flex: 1;
              margin-left:25px;
            }
            .content p{
                font-size: 15px;
                line-height: 22px;
                color: #494949;
            }
        }
        #echarts,#echarts1{
            width: 100%;
            height: 254px;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/views/followUp/followUpDetails.vue